var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      _c("div", { staticClass: "d-flex" }, [
        _c("h2", { staticClass: "h2_title mb-1" }, [
          _vm._v("Información de Baja Comercial")
        ])
      ]),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            "mt-5": "",
            layout: "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Cliente",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.cliente,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "cliente", $$v)
                  },
                  expression: "data.cliente"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Nombre Baja",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.nombre_baja,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "nombre_baja", $$v)
                  },
                  expression: "data.nombre_baja"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Fecha Creación",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.fecha_alta,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "fecha_alta", $$v)
                  },
                  expression: "data.fecha_alta"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Cantidad de Equipos",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.bajaFinalizada
                },
                model: {
                  value: _vm.data.cantidad_equipos,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "cantidad_equipos", $$v)
                  },
                  expression: "data.cantidad_equipos"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Cantidad Perifericos",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.bajaFinalizada
                },
                model: {
                  value: _vm.data.cantidad_perifericos,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "cantidad_perifericos", $$v)
                  },
                  expression: "data.cantidad_perifericos"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Total",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.total,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "total", $$v)
                  },
                  expression: "data.total"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Observaciones",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.observaciones,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "observaciones", $$v)
                  },
                  expression: "data.observaciones"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Fecha Fin Definitiva",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.fecha_fin_definitiva,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "fecha_fin_definitiva", $$v)
                  },
                  expression: "data.fecha_fin_definitiva"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Area Responsable",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.area_responsable,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "area_responsable", $$v)
                  },
                  expression: "data.area_responsable"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Nota de Venta",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.nombre_nota_venta,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "nombre_nota_venta", $$v)
                  },
                  expression: "data.nombre_nota_venta"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Situciación Baja",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.nombre_situcion_baja,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "nombre_situcion_baja", $$v)
                  },
                  expression: "data.nombre_situcion_baja"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Motivo de Baja",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.motiname,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "motiname", $$v)
                  },
                  expression: "data.motiname"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Tipo de Baja",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.nombre_tipo_baja,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "nombre_tipo_baja", $$v)
                  },
                  expression: "data.nombre_tipo_baja"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Plataforma",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.plataforma,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "plataforma", $$v)
                  },
                  expression: "data.plataforma"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Motivo de Anulación",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.motivo_anula,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "motivo_anula", $$v)
                  },
                  expression: "data.motivo_anula"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Mandante",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.mandante,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "mandante", $$v)
                  },
                  expression: "data.mandante"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Descripción Anulación",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.descripcion_anulacion,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "descripcion_anulacion", $$v)
                  },
                  expression: "data.descripcion_anulacion"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Tramo Baja",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.bajaFinalizada,
                  items: _vm.tramos,
                  "item-text": "nombre_tramo",
                  "item-value": "nombre_tramo",
                  clearable: "",
                  "prepend-icon": "home_repair_service"
                },
                model: {
                  value: _vm.data.tramo_baja_comercial,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "tramo_baja_comercial", $$v)
                  },
                  expression: "data.tramo_baja_comercial"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Propietario",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.propietario,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "propietario", $$v)
                  },
                  expression: "data.propietario"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Ejecutivo",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.ejecutivo,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ejecutivo", $$v)
                  },
                  expression: "data.ejecutivo"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Estado",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.estado,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "estado", $$v)
                  },
                  expression: "data.estado"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Estado CRM",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.razon_estado,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "razon_estado", $$v)
                  },
                  expression: "data.razon_estado"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Glosa CRM",
                  readonly: !_vm.esEdicion,
                  disabled: _vm.esEdicion
                },
                model: {
                  value: _vm.data.glosa_api_crm,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "glosa_api_crm", $$v)
                  },
                  expression: "data.glosa_api_crm"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }